/*
 * Fraunhofer Institute for Computer Graphics Research (IGD)
 * Competence Center for Information Visualization and Visual Analytics
 *
 * Copyright (c) 2018 Fraunhofer IGD. All rights reserved.
 *
 * This source code is property of the Fraunhofer IGD and underlies
 * copyright restrictions. It may only be used with explicit
 * permission from the respective owner.
 */
import RestServiceHelpers from './RestServiceHelpers';
import { ContentType, } from './ContentType';
import ConnectionError from './ConnectionError';
export default class RestServicePromiseUtils {
    /**
     *  endpoint: The endpoint of the REST-Service, e.g. /api/time
     *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
     */
    static jsonGET(endpoint, additionalOptions) {
        const getEndpoint = RestServiceHelpers.assembleEndpoint(endpoint, additionalOptions);
        const getRequest = RestServiceHelpers.assembleRequestGET(ContentType.Json, additionalOptions);
        return RestServicePromiseUtils.jsonFetch(getEndpoint, getRequest);
    }
    /**
     *  endpoint: The endpoint of the REST-Service, e.g. /api/time
     *  bodyContentObj: The body-content of the POST-message
     *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
     */
    static jsonPUT(endpoint, bodyContentObj, additionalOptions) {
        const putEndpoint = RestServiceHelpers.assembleEndpoint(endpoint, additionalOptions);
        const putRequest = RestServiceHelpers.assembleRequestWithBody('PUT', bodyContentObj, ContentType.Json, additionalOptions);
        return RestServicePromiseUtils.jsonFetch(putEndpoint, putRequest);
    }
    /**
     *  endpoint: The endpoint of the REST-Service, e.g. /api/time
     *  bodyContentObj: The body-content of the POST-message
     *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
     */
    static jsonDELETE(endpoint, bodyContentObj, additionalOptions) {
        const deleteEndpoint = RestServiceHelpers.assembleEndpoint(endpoint, additionalOptions);
        const deleteRequest = RestServiceHelpers.assembleRequestWithBody('DELETE', bodyContentObj, ContentType.Json, additionalOptions);
        return RestServicePromiseUtils.jsonFetch(deleteEndpoint, deleteRequest);
    }
    /**
     *  endpoint: The endpoint of the REST-Service, e.g. /api/time
     *  bodyContentObj: The body-content of the POST-message
     *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
     */
    static jsonPOST(endpoint, bodyContentObj, additionalOptions) {
        const postEndpoint = RestServiceHelpers.assembleEndpoint(endpoint, additionalOptions);
        const postRequest = RestServiceHelpers.assembleRequestWithBody('POST', bodyContentObj, ContentType.Json, additionalOptions);
        return RestServicePromiseUtils.jsonFetch(postEndpoint, postRequest);
    }
    /**
     *  endpoint: The endpoint of the REST-Service, e.g. /api/time
     *  bodyContentObj: The body-content of the PATCH-message
     *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
     */
    static jsonPATCH(endpoint, bodyContentObj, additionalOptions) {
        const patchEndpoint = RestServiceHelpers.assembleEndpoint(endpoint, additionalOptions);
        const patchRequest = RestServiceHelpers.assembleRequestWithBody('PATCH', bodyContentObj, ContentType.Json, additionalOptions);
        return RestServicePromiseUtils.jsonFetch(patchEndpoint, patchRequest);
    }
    /**
     *  endpoint: The endpoint of the REST-Service, e.g. /api/time
     *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
     */
    static textGET(endpoint, additionalOptions) {
        const getEndpoint = RestServiceHelpers.assembleEndpoint(endpoint, additionalOptions);
        const getRequest = RestServiceHelpers.assembleRequestGET(ContentType.Text, additionalOptions);
        return RestServicePromiseUtils.textFetch(getEndpoint, getRequest);
    }
    /**
     *  endpoint: The endpoint of the REST-Service, e.g. /api/time
     *  bodyContentObj: The body-content of the POST-message
     *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
     */
    static textPUT(endpoint, bodyContentObj, additionalOptions) {
        const putEndpoint = RestServiceHelpers.assembleEndpoint(endpoint, additionalOptions);
        const putRequest = RestServiceHelpers.assembleRequestWithBody('PUT', bodyContentObj, ContentType.Text, additionalOptions);
        return RestServicePromiseUtils.textFetch(putEndpoint, putRequest);
    }
    /**
     *  endpoint: The endpoint of the REST-Service, e.g. /api/time
     *  bodyContentObj: The body-content of the POST-message
     *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
     */
    static textDELETE(endpoint, bodyContentObj, additionalOptions) {
        const deleteEndpoint = RestServiceHelpers.assembleEndpoint(endpoint, additionalOptions);
        const deleteRequest = RestServiceHelpers.assembleRequestWithBody('DELETE', bodyContentObj, ContentType.Text, additionalOptions);
        return RestServicePromiseUtils.textFetch(deleteEndpoint, deleteRequest);
    }
    /**
     *  endpoint: The endpoint of the REST-Service, e.g. /api/time
     *  bodyContentObj: The body-content of the POST-message
     *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
     */
    static textPOST(endpoint, bodyContentObj, additionalOptions) {
        const postEndpoint = RestServiceHelpers.assembleEndpoint(endpoint, additionalOptions);
        const postRequest = RestServiceHelpers.assembleRequestWithBody('POST', bodyContentObj, ContentType.Text, additionalOptions);
        return RestServicePromiseUtils.textFetch(postEndpoint, postRequest);
    }
    /**
     *  endpoint: The endpoint of the REST-Service, e.g. /api/time
     *  bodyContentObj: The body-content of the PATCH-message
     *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
     */
    static textPATCH(endpoint, bodyContentObj, additionalOptions) {
        const patchEndpoint = RestServiceHelpers.assembleEndpoint(endpoint, additionalOptions);
        const patchRequest = RestServiceHelpers.assembleRequestWithBody('PATCH', bodyContentObj, ContentType.Text, additionalOptions);
        return RestServicePromiseUtils.textFetch(patchEndpoint, patchRequest);
    }
    /**
     *  endpoint: The endpoint of the REST-Service, e.g. /api/time
     *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
     */
    static arrayBufferGET(endpoint, additionalOptions) {
        const getEndpoint = RestServiceHelpers.assembleEndpoint(endpoint, additionalOptions);
        const getRequest = RestServiceHelpers.assembleRequestGET(ContentType.ArrayBuffer, additionalOptions);
        return RestServicePromiseUtils.arrayBufferFetch(getEndpoint, getRequest);
    }
    /**
     *  endpoint: The endpoint of the REST-Service, e.g. /api/time
     *  bodyContentObj: The body-content of the POST-message
     *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
     */
    static arrayBufferPUT(endpoint, bodyContentObj, additionalOptions) {
        const putEndpoint = RestServiceHelpers.assembleEndpoint(endpoint, additionalOptions);
        const putRequest = RestServiceHelpers.assembleRequestWithBody('PUT', bodyContentObj, ContentType.ArrayBuffer, additionalOptions);
        return RestServicePromiseUtils.arrayBufferFetch(putEndpoint, putRequest);
    }
    /**
     *  endpoint: The endpoint of the REST-Service, e.g. /api/time
     *  bodyContentObj: The body-content of the POST-message
     *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
     */
    static arrayBufferDELETE(endpoint, bodyContentObj, additionalOptions) {
        const deleteEndpoint = RestServiceHelpers.assembleEndpoint(endpoint, additionalOptions);
        const deleteRequest = RestServiceHelpers.assembleRequestWithBody('DELETE', bodyContentObj, ContentType.ArrayBuffer, additionalOptions);
        return RestServicePromiseUtils.arrayBufferFetch(deleteEndpoint, deleteRequest);
    }
    /**
     *  endpoint: The endpoint of the REST-Service, e.g. /api/time
     *  bodyContentObj: The body-content of the POST-message
     *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
     */
    static arrayBufferPOST(endpoint, bodyContentObj, additionalOptions) {
        const postEndpoint = RestServiceHelpers.assembleEndpoint(endpoint, additionalOptions);
        const postRequest = RestServiceHelpers.assembleRequestWithBody('POST', bodyContentObj, ContentType.ArrayBuffer, additionalOptions);
        return RestServicePromiseUtils.arrayBufferFetch(postEndpoint, postRequest);
    }
    /**
     *  endpoint: The endpoint of the REST-Service, e.g. /api/time
     *  bodyContentObj: The body-content of the PATCH-message
     *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
     */
    static arrayBufferPATCH(endpoint, bodyContentObj, additionalOptions) {
        const patchEndpoint = RestServiceHelpers.assembleEndpoint(endpoint, additionalOptions);
        const patchRequest = RestServiceHelpers.assembleRequestWithBody('PATCH', bodyContentObj, ContentType.ArrayBuffer, additionalOptions);
        return RestServicePromiseUtils.arrayBufferFetch(patchEndpoint, patchRequest);
    }
    /**
     *  endpoint: The endpoint of the REST-Service, e.g. /api/time
     *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
     */
    static blobGET(endpoint, additionalOptions) {
        const getEndpoint = RestServiceHelpers.assembleEndpoint(endpoint, additionalOptions);
        const getRequest = RestServiceHelpers.assembleRequestGET(ContentType.Blob, additionalOptions);
        return RestServicePromiseUtils.blobFetch(getEndpoint, getRequest);
    }
    /**
     *  endpoint: The endpoint of the REST-Service, e.g. /api/time
     *  bodyContentObj: The body-content of the POST-message
     *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
     */
    static blobPUT(endpoint, bodyContentObj, additionalOptions) {
        const putEndpoint = RestServiceHelpers.assembleEndpoint(endpoint, additionalOptions);
        const putRequest = RestServiceHelpers.assembleRequestWithBody('PUT', bodyContentObj, ContentType.Blob, additionalOptions);
        return RestServicePromiseUtils.blobFetch(putEndpoint, putRequest);
    }
    /**
     *  endpoint: The endpoint of the REST-Service, e.g. /api/time
     *  bodyContentObj: The body-content of the POST-message
     *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
     */
    static blobDELETE(endpoint, bodyContentObj, additionalOptions) {
        const deleteEndpoint = RestServiceHelpers.assembleEndpoint(endpoint, additionalOptions);
        const deleteRequest = RestServiceHelpers.assembleRequestWithBody('DELETE', bodyContentObj, ContentType.Blob, additionalOptions);
        return RestServicePromiseUtils.blobFetch(deleteEndpoint, deleteRequest);
    }
    /**
     *  endpoint: The endpoint of the REST-Service, e.g. /api/time
     *  bodyContentObj: The body-content of the POST-message
     *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
     */
    static blobPOST(endpoint, bodyContentObj, additionalOptions) {
        const postEndpoint = RestServiceHelpers.assembleEndpoint(endpoint, additionalOptions);
        const postRequest = RestServiceHelpers.assembleRequestWithBody('POST', bodyContentObj, ContentType.Blob, additionalOptions);
        return RestServicePromiseUtils.blobFetch(postEndpoint, postRequest);
    }
    /**
     *  endpoint: The endpoint of the REST-Service, e.g. /api/time
     *  bodyContentObj: The body-content of the PATCH-message
     *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
     */
    static blobPATCH(endpoint, bodyContentObj, additionalOptions) {
        const patchEndpoint = RestServiceHelpers.assembleEndpoint(endpoint, additionalOptions);
        const patchRequest = RestServiceHelpers.assembleRequestWithBody('PATCH', bodyContentObj, ContentType.Blob, additionalOptions);
        return RestServicePromiseUtils.blobFetch(patchEndpoint, patchRequest);
    }
    static jsonFetch(endpoint, requestObj) {
        const resultMapFunc = (result) => result.json();
        return RestServicePromiseUtils.fetch(endpoint, requestObj, resultMapFunc);
    }
    static textFetch(endpoint, requestObj) {
        const resultMapFunc = (result) => result.text();
        return RestServicePromiseUtils.fetch(endpoint, requestObj, resultMapFunc);
    }
    static blobFetch(endpoint, requestObj) {
        const resultMapFunc = (result) => result.blob();
        return RestServicePromiseUtils.fetch(endpoint, requestObj, resultMapFunc);
    }
    static arrayBufferFetch(endpoint, requestObj) {
        const resultMapFunc = (result) => result.arrayBuffer();
        return RestServicePromiseUtils.fetch(endpoint, requestObj, resultMapFunc);
    }
    static fetch(endpoint, requestObj, resultMapFunc) {
        return fetch(endpoint, requestObj)
            .then((response) => {
            if (response.ok) {
                return resultMapFunc(response);
            }
            else {
                throw new ConnectionError(response);
            }
        });
    }
}
//# sourceMappingURL=RestServicePromiseUtils.js.map